module.exports = __webpack_public_path__ + "static/img/bg-pt.1e4ce940.webp";